// @mui material components
import Grid from "@mui/material/Grid";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftButton from "components/SoftButton";
import PropTypes from "prop-types";

function About({ onNext }) {
  return (
    <SoftBox>
      <SoftBox width="80%" textAlign="center" mx="auto" mb={4}>
        <SoftTypography variant="h4" fontWeight="bold">
          UDS Game Server
        </SoftTypography>
        <SoftTypography variant="body1" fontWeight="regular" color="text">
          UDS Game Server bietet eine leistungsstarke, skalierbare und zuverlässige Lösung für Ihr
          Gaming-Erlebnis. Mit moderner Hardware und einfacher Konfiguration ist er die
          ideale Wahl für Spielergemeinschaften jeder Größe.
        </SoftTypography>
      </SoftBox>
      <SoftBox mt={2}>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6}>
            <SoftTypography variant="h6" fontWeight="medium">
              Hauptmerkmale
            </SoftTypography>
            <SoftTypography variant="body2" color="text">
              - Hohe Performance und Zuverlässigkeit <br />
              - Skalierbare Ressourcen (RAM, CPU, Speicher) <br />
              - 99,9% Verfügbarkeit <br />
              - DDoS-Schutz <br />
              - 24/7 Technischer Support
            </SoftTypography>
          </Grid>
          <Grid item xs={12} sm={6}>
            <SoftTypography variant="h6" fontWeight="medium">
              Vorteile
            </SoftTypography>
            <SoftTypography variant="body2" color="text">
              - Flexibel anpassbare Ressourcen <br />
              - Transparente Preisstruktur <br />
              - Einfache Verwaltung <br />
              - Optimierte Performance für verschiedene Spiele <br />
              - Backup-Funktion für Ihre Spielstände
            </SoftTypography>
          </Grid>
        </Grid>
      </SoftBox>
      <SoftBox mt={4} textAlign="center">
        <SoftButton color="primary" onClick={onNext}>
          Weiter zur Konfiguration
        </SoftButton>
      </SoftBox>
    </SoftBox>
  );
}

About.propTypes = {
  onNext: PropTypes.func.isRequired,
};

export default About;